import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NumericDateFormatPipe } from './numeric-date-format.pipe';
import { TimeFormatPipe } from './time-format.pipe';

@NgModule({
  declarations: [NumericDateFormatPipe, TimeFormatPipe],
  imports: [CommonModule],
  exports: [NumericDateFormatPipe, TimeFormatPipe],
  providers: [NumericDateFormatPipe]
})
export class NumericDateFormatModule {}

export * from './date-format.helper';
export * from './numeric-date-format.pipe';
export * from './time-format.pipe';
export * from './date-format-types';
